<template>
    <div>
        <div class="show-navigation">
            <chat-header></chat-header>

            <div class="container">

                <chat-menu></chat-menu>

                <div class="form-control-wrapper mb--30">
                    <svg class="icon">
                        <use xlink:href="/img/icon-sprite.svg#search"></use>
                    </svg>
                    <input type="text" placeholder="Search" v-model="search" class="form-control form-control--sm form-control--gray"/>
                </div>

                <p class="text--uppercase weight--bold opacity--md mb--0" v-if="onlineFriends.count()">Online</p>

                <template v-for="friend in onlineFriends" v-if="friends">
                    <div class="profile profile--horizontal profile--horizontal-xs profile--separator">
                        <figure class="profile__avatar profile__avatar--xs mr--sm">
                    <span class="profile__avatar__img">
                        <img :src="friend.avatar" alt="">
                        <span class="status status--success"></span>
                    </span>
                        </figure>

                        <div class="profile__text">
                            <div class="profile__name">{{ friend.nick }}</div>
                        </div>

                        <div class="profile__buttons">
                            <router-link :to="'/user/' + friend.id" class="btn btn--sm miw--80 btn--default-gray">Profile</router-link>
                            <button @click="sendMessage(friend.id)" class="btn btn--sm miw--80 btn--secondary">Send</button>
                        </div>
                    </div>
                </template>

                <p class="text--uppercase weight--bold opacity--md mb--0 mt--30">All friends</p>

                <div class="alert bg--layer-light mb--20 mt--10" v-if="! onlineFriends.count() && !offlineFriends.count()">
                    No friends found.
                </div>

                <template v-for="friend in offlineFriends" v-if="friends">
                    <div class="profile profile--horizontal profile--horizontal-xs profile--separator">
                        <figure class="profile__avatar profile__avatar--xs mr--sm">
                    <span class="profile__avatar__img">
                        <img :src="friend.avatar" alt="">
                    </span>
                        </figure>

                        <div class="profile__text">
                            <div class="profile__name">{{ friend.nick }}</div>
                        </div>

                        <div class="profile__buttons">
                            <router-link :to="'/user/' + friend.id" class="btn btn--sm miw--80 btn--default-gray">Profile</router-link>
                            <button @click="sendMessage(friend.id)" class="btn btn--sm miw--80 btn--secondary">Send</button>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <navigation></navigation>
    </div>
</template>

<script>
import api from "../../api/chat";
import {mapState} from "vuex";
import Navigation from "../partial/Navigation";
import ChatMenu from "./partial/chatMenu";
import ChatHeader from "./partial/chatHeader";

export default {
    name: "Friends",

    components: {ChatHeader, ChatMenu, Navigation},

    data: function () {
        return {
            friends: null,
            search: '',
        }
    },

    computed: {
        ...mapState('auth', [
            'user'
        ]),

        onlineFriends() {
            return collect(this.friends)
                .when(this.search.length > 0, (friends) => friends.filter((friend) => friend.nick.search(this.search) > -1))
                .filter(({is_online}) => is_online == true)
        },

        offlineFriends() {
            return collect(this.friends)
                .when(this.search.length > 0, (friends) => friends.filter((friend) => friend.nick.search(this.search) > -1))
                .filter(({is_online}) => is_online != true)
        }
    },

    methods: {
        sendMessage(userId) {
            api.createChat(this.user.id, userId).then((response) => {
                this.$router.push('/chat/' + response.data.data.id)
            })
        },

        async loadFriends() {
            try {
                let response = await api.loadFriends()

                this.friends = response.data
            } catch (e) {

            }
        }
    },

    created() {
        this.loadFriends()

        Quiz.$on('friendOnline', () => this.loadFriends())
    },

    mounted() {
        $('body').addClass('body--white')
    },

    beforeDestroy() {
        Quiz.$off('friendOnline')
        $('body').removeClass('body--white')
    }
}
</script>
